import { defineComponent as _defineComponent } from 'vue'

import { TranslateResult } from 'vue-i18n'

interface PropsType {
  description?: string | TranslateResult
}

export default /*#__PURE__*/_defineComponent({
  __name: 'm-empty',
  props: {
    description: { default: '' }
  },
  setup(__props: any) {

const props = __props as { description: string | TranslateResult }



return { __sfc: true,props }
}

})